import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFavoriteMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

const useCreateFavoriteMeal = (currentDay) => {
    const [isAdding, setIsAdding] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: createFavoriteMeal,
        onError: (error) => console.error('Failed to create favorite meal:', error)
    });

    const createFavoriteMealAndSync = async ({ mealId, name }) => {
        setIsAdding(true);

        try {
            await mutation.mutateAsync({ mealId, name });

            await refetchDiaryAndEnergy(queryClient, currentDay);
        } catch (error) {
            console.error('Add favorite and sync failed:', error);
        } finally {
            setIsAdding(false);
        }
    };

    return {
        createFavoriteMeal: createFavoriteMealAndSync,
        isAdding: isAdding,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error
    };
};

export default useCreateFavoriteMeal;
